import { render, staticRenderFns } from "./ManagePartners.vue?vue&type=template&id=57048bcc&"
import script from "./ManagePartners.vue?vue&type=script&lang=js&"
export * from "./ManagePartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports